import { defineComponent as _defineComponent } from 'vue'
import { AlertBlock } from '@shared/ui';
    import IconBase from '@ve/services/IconBase.vue';
    import asyncSvGLoader from '@ve/services/asyncSvgLoader';
    import confirm from './images/confirm.svg';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TourAttentionAlert',
  setup(__props) {

    const confirmIcon = asyncSvGLoader(confirm);


return { __sfc: true,confirmIcon, AlertBlock, IconBase }
}

})